<template>
  <div class="content-max-width">

    <section class="title-module">
      <h1>
        Memberships
        <small>Mema</small>
      </h1>
    </section>

    <section class="body-container"  v-if="current_step === 1">
      <div class="left-block wysiwyg">
        <div v-html="content"></div>
      </div>
    </section>

    <section class="memberships-container">

      <StepOne
        v-if="current_step === 1"
        :memberships="memberships"
        v-on:membershipTerms="changeMembershipType"
      ></StepOne>

      <StepTwo
        v-if="current_step === 2"
        :terms="your_terms"
        v-on:termType="changeTermType"
        v-on:back="backTo"
        :data="data"
        :term_terms="term_terms"
      ></StepTwo>

      <StepThree
        v-if="current_step === 3"
        :term='term' :price='price'
        v-on:towelType="changeTowelType"
        v-on:back="backTo"
      ></StepThree>


    </section>
  </div>
</template>

<script>
import StepOne from './StepOne'
import StepTwo from './StepTwo'
import StepThree from './StepThree'

export default {
  props: {
    memberships: Array,
    content: String,
    data: Array
  },
  components: {
    StepOne, StepTwo, StepThree
  },

  data () {
    return {
      current_step: 1,
      payload: {
        membership_type: null,
        term_type: 0,
        towel_type: false
      },
      your_terms: [],
      term_terms: '',
      term: {},
      price: '',
      featured: []
    };
  },

  methods: {
    backTo (number) {
      console.log(number)
      this.current_step = number
    },

    changeMembershipType (terms, term_terms) {
      this.your_terms = terms
      this.term_terms = term_terms
      this.current_step = 2
    },

    changeTermType (term, price) {
      this.price = price
      this.term = term
      this.current_step = 3
    },

    changeTowelType (boolean) {
      this.payload.towel_type = boolean
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/memberships/Index.vue